module.exports = __webpack_public_path__ + "img/81.baecb3e3.jpg";